export interface ISerologyTest {
    id: number,
    name: string,
    cost: number,
    isRequired: number
}